
import React from "react";
import "./StoreOfferCard.css";

// Flat / Upto  +  4.80%  +  Cashback  ko alag-alag nikalta hai
const parseCashback = (text = "") => {
  const m = text.match(/^(.*?)(\d+(?:\.\d+)?\s*%)(.*)$/);
  if (!m) return { up: "", percent: text.trim(), label: "" };
  return {
    up: m[1].trim(),
    percent: m[2].replace(/\s+/g, ""),
    label: m[3].trim(),
  };
};

const StoreOfferCard = ({ item, onClick }) => {
  const { up, percent, label } = parseCashback(item.cashback_text || "");

  return (
    <div className="offer-card" onClick={onClick} style={{ cursor: "pointer" }}>
      <section className="top">
        <div className="top-content">
          <div className="tag-icon">
            <div className="tag"></div>
            <div className="hole"></div>
            <div className="percent">%</div>
          </div>
          <div className="discount">
            {(() => {
              const text = item.discount_text || `${item.discount}%` || "Sale";
              const match = text.match(/.*?\d+(\.\d+)?%/);
              if (!match) return text;
              const mainPart = match[0];
              const restPart = text.replace(mainPart, "").trim();
              return (
                <>
                  <span className="discount-main">{mainPart}</span>
                  {restPart && <span className="discount-sub"> {restPart}</span>}
                </>
              );
            })()}
          </div>
        </div>
      </section>

      <div className="dots left">
        {[...Array(16)].map((_, i) => <span key={i}></span>)}
      </div>
      <div className="dots right">
        {[...Array(16)].map((_, i) => <span key={i}></span>)}
      </div>

      <section className="amazon-area">
        <div className="amazon-logo">
          {item.logo ? (
            <img
              src={`${process.env.REACT_APP_API}uploads/${item.logo}`}
              alt={item.name}
              loading="lazy"
            />
          ) : (
            item.name
          )}
        </div>
      </section>

      <section className="reward">
        <div className="gift-circle">🎁</div>
        <div className="divider"></div>
        <div className="reward-text">
          {up && <div className="reward-up">{up}</div>}
          <div className="reward-percent">{percent}</div>
          {label && <div className="reward-label">{label}</div>}
        </div>
      </section>
    </div>
  );
};

export default StoreOfferCard;